import axios from 'axios/dist/axios';
import Vue from 'vue';
import router from '../../../common/router/router';

let code = (function () {
    return {
        getCookie: function (name) {
            let value = "; " + document.cookie;
            let parts = value.split("; " + name + "=");
            if (parts.length === 2) {
                return parts.pop().split(";").shift();
            }
        }
    }
})();


const relatedSymptomStates = {
    NONE: "NONE", //The Symptom is not selected
    HAVE_SYMPTOM: "HAVE_SYMPTOM", //The Symptom is selected. The person has that Symptom
    NOT_HAVE_SYMPTOM: "NOT_HAVE_SYMPTOM" //The person tells that he doesn't have that Symptom
};

const guiVariants = {
    PRIORITY_LIST: "PRIORITY_LIST",
    SYMPTOM_VIEW: "SYMPTOM_VIEW",
};

const defaultState = {
    relatedSymptomStates: relatedSymptomStates, // Constants.

    di1PriorityLevelHighest: null,
    relatedSymptomList: [],
    selectedRelatedSymptomList: [],
    sharedQuestionsData: [],

    isQuestionListModeEnabled: false,

    mustShowFullQuestion: true,
    footerBtnNext: {
        isEnabled: true
    },
    selectedMainSymptom: '',
    selectedRelatedSymptomListPriority: [],
    symptomDescription:'',
    symptomCode: '',
    mustShowAssessmentList: code.getCookie('view'),
   // mustShowAssessmentList: false,
    symptomName: '',
    symptomText: '',
    relatedSymptomName: '',
    answerCode: '',
    noOtherSymptomsCheck: false,
    noOtherSymptoms: false,
    pendingRequest: false,
    symptomType:''
};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    relatedSymptomStates:               defaultState.relatedSymptomStates, // Constants.

    di1PriorityLevelHighest:            defaultState.di1PriorityLevelHighest,
    relatedSymptomList:                 defaultState.relatedSymptomList,
    selectedRelatedSymptomList:         defaultState.selectedRelatedSymptomList,
    sharedQuestionsData:                defaultState.sharedQuestionsData,

    isQuestionListModeEnabled:          defaultState.isQuestionListModeEnabled,

    mustShowFullQuestion:               defaultState.mustShowFullQuestion,
    footerBtnNext: {
        isEnabled:                      defaultState.footerBtnNext.isEnabled
    },
    selectedMainSymptom:                defaultState.selectedMainSymptom,
    selectedRelatedSymptomListPriority: defaultState.selectedRelatedSymptomListPriority,
    symptomDescription                : defaultState.symptomDescription,
    symptomCode                       : defaultState.symptomCode,
    mustShowAssessmentList            : defaultState.mustShowAssessmentList,
    symptomName                       : defaultState.symptomName,
    symptomText                       : defaultState.symptomText,
    relatedSymptomName                : defaultState.relatedSymptomName,
    answerCode                        : defaultState.answerCode,
    noOtherSymptomsCheck              : defaultState.noOtherSymptomsCheck,
    noOtherSymptoms                   : defaultState.noOtherSymptoms,
    pendingRequest                    : defaultState.pendingRequest,
    symptomType                       : defaultState.symptomType
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getRelatedSymptomStates: state => state.relatedSymptomStates,

    getDi1PriorityLevelHighest: state => state.di1PriorityLevelHighest,
    getRelatedSymptomList: state => state.relatedSymptomList,
    getSelectedRelatedSymptomList: state => state.selectedRelatedSymptomList,

    getSharedQuestionList (state) {
        return (typeof state.sharedQuestionsData.questions !== 'undefined')
            ? state.sharedQuestionsData.questions
            : [];
    },
    getSharedQuestionsCountAnswered () {
        return state.sharedQuestionsData.countAnswered || 0;
    },
    getSharedQuestionsCountTotal () {
        return state.sharedQuestionsData.countTotal || 0;
    },

    getIsQuestionListModeEnabled: state => state.isQuestionListModeEnabled,
    getMustShowFullQuestion: state => state.mustShowFullQuestion,
    getIsFooterNextBtnEnabled (state) {
        return !!(state.footerBtnNext.isEnabled);
    },
    getMainSymptom: state => state.selectedMainSymptom,
    getSelectedRelatedSymptomListPriority: state => state.selectedRelatedSymptomListPriority,
    getSymptomDescription: state => state.symptomDescription,
    getSymptomCode: state => state.symptomCode,
    getMustShowAssessmentList: state => state.mustShowAssessmentList,
    getSymptomName: state => state.symptomName,
    getSymptomText: state => state.symptomText,
    getRelatedSymptomName: state => state.relatedSymptomName,
    getAnswerCode: state => state.answerCode,
    getNoOtherSymptomsCheck: state => state.noOtherSymptomsCheck,
    getNoOtherSymptoms: state => state.noOtherSymptoms,
    getPendingRequest: state => state.pendingRequest,
    getSymptomType: state => state.symptomType
};


// ======================================================================
// Actions
// ======================================================================

const actions = {

    /**
     * Load symptom questions data from the server.
     * @param {Object} - Vuex: commit, rootGetters
     * @return {Promise}
     */
    loadSymptomsQuestionsData ({commit, dispatch, rootGetters}) {
        let promise = new Promise((resolve, reject) => {

            let mainSymptomCode = rootGetters['ChooseMainSymptomStore/getSelectedMainSymptomCode'];

            let requestParams = {};
            if (mainSymptomCode !== "") {
                requestParams = {
                    symptomCode: mainSymptomCode
                };
            }

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/chooseMainSymptom', requestParams);
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    commit("resetStore");

                    if (response.data.data) {
                        if (typeof response.data.data.ASSESSMENT_SYMPTOMS_VIEW !== "undefined") {
                            commit("setDi1PriorityLevelHighest", response.data.data.ASSESSMENT_SYMPTOMS_VIEW.di1PriorityLevelHighest);
                        }
                        if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined" && typeof response.data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined") {
                            commit("setRelatedSymptomList", response.data.data.RELATED_SYMPTOM_LIST.symptoms);
                        }
                        if (typeof response.data.data.SYMPTOM_LIST !== "undefined" && typeof response.data.data.SYMPTOM_LIST.symptoms !== "undefined") {
                            commit("setSelectedRelatedSymptomList", response.data.data.SYMPTOM_LIST.symptoms);
                        }
                        if (typeof response.data.data.SHARED_QUESTIONS !== "undefined") {
                            commit("setSharedQuestionsData", response.data.data.SHARED_QUESTIONS);
                        }
                        if (typeof response.data.data.MAIN_SYMPTOM !== "undefined") {
                            commit("setMainSymptom", response.data.data.MAIN_SYMPTOM);
                        }
                        if (typeof response.data.data.START_QUESTIONS !== "undefined") {
                            commit('AssessmentStartStore/setStartQuestionsData', response.data.data.START_QUESTIONS, {root: true});
                        }
                        if (typeof response.data.data.PATIENT_DATA !== "undefined") {
                            commit('AssessmentStartStore/setPatientProfileData', response.data.data.PATIENT_DATA, {root: true});
                        }
                        if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined" && typeof response.data.data.RELATED_SYMPTOM_LIST.noOtherSymptomsCheck) {
                            commit("setNoOtherSymptomsCheck", response.data.data.RELATED_SYMPTOM_LIST.noOtherSymptomsCheck);
                        }
                        if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined" && typeof response.data.data.RELATED_SYMPTOM_LIST.noOtherSymptoms) {
                            commit("setNoOtherSymptoms", response.data.data.RELATED_SYMPTOM_LIST.noOtherSymptoms);
                        }
                        if (typeof response.data.data.SHORT_ANSWERS_PREVIEW !== "undefined") {
                            commit('AssessmentStartStore/setShortAnswersPreview', response.data.data.SHORT_ANSWERS_PREVIEW, {root: true});
                        }
                        if (typeof response.data.data.VITAL_PARAMETERS !== "undefined") {
                            dispatch('VitalParametersStore/setupVitalParameters', response.data.data.VITAL_PARAMETERS, {root: true});
                        }
                    }

                    commit('ChooseMainSymptomStore/clearSelectedMainSymptomCode', {}, {root: true});
                    dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });
                    resolve(response);
                }
                else {
                    reject(error);
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    loadSymptomsQuestionsDataForListMode ({commit, dispatch, rootGetters}) {
        let promise = new Promise((resolve, reject) => {

            let mainSymptomCode = rootGetters['ChooseMainSymptomStore/getSelectedMainSymptomCode'];

            let requestParams = {};
            if (mainSymptomCode !== "") {
                requestParams = {
                    symptomCode: mainSymptomCode
                };
            }

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/chooseMainSymptomPriority', requestParams);
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    commit("resetStore");

                    if (response.data.data) {

                        if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined" && typeof response.data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined") {
                            commit("setRelatedSymptomList", response.data.data.RELATED_SYMPTOM_LIST.symptoms);
                        }

                        if (typeof response.data.data.MAIN_SYMPTOM !== "undefined") {
                            commit("setMainSymptom", response.data.data.MAIN_SYMPTOM);
                        }
                        if (typeof response.data.data.START_QUESTIONS !== "undefined") {
                            commit('AssessmentStartStore/setStartQuestionsData', response.data.data.START_QUESTIONS, {root: true});
                        }
                        if (typeof response.data.data.PATIENT_DATA !== "undefined") {
                            commit('AssessmentStartStore/setPatientProfileData', response.data.data.PATIENT_DATA, {root: true});
                        }
                        if (typeof response.data.data.SYMPTOM_LIST_PRIORITY !== "undefined" && typeof response.data.data.SYMPTOM_LIST_PRIORITY.questions !== "undefined") {
                            commit("setSelectedRelatedSymptomListPriority", response.data.data.SYMPTOM_LIST_PRIORITY.questions);
                        }
                        if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined" && typeof response.data.data.RELATED_SYMPTOM_LIST.noOtherSymptomsCheck) {
                            commit("setNoOtherSymptomsCheck", response.data.data.RELATED_SYMPTOM_LIST.noOtherSymptomsCheck);
                        }

                        if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined" && typeof response.data.data.RELATED_SYMPTOM_LIST.noOtherSymptoms) {
                            commit("setNoOtherSymptoms", response.data.data.RELATED_SYMPTOM_LIST.noOtherSymptoms);
                        }
                        if (typeof response.data.data.SHORT_ANSWERS_PREVIEW !== "undefined") {
                            commit('AssessmentStartStore/setShortAnswersPreview', response.data.data.SHORT_ANSWERS_PREVIEW, {root: true});
                        }
                        if (typeof response.data.data.VITAL_PARAMETERS !== "undefined") {
                            dispatch('VitalParametersStore/setupVitalParameters', response.data.data.VITAL_PARAMETERS, {root: true});
                        }
                    }

                    commit('ChooseMainSymptomStore/clearSelectedMainSymptomCode', {}, {root: true});
                    dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });
                    resolve(response);
                }
                else {
                    reject(error);
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    /**
     * Update symptom question data
     * @param {Object} - Vuex: dispatch, commit
     * @param data - new response data
     * */
    updateSymptomQuestionData({dispatch, commit}, data) {
        if (typeof data.data.MAIN_SYMPTOM !== "undefined") {
            commit("setMainSymptom", data.data.MAIN_SYMPTOM);
        }

        if (typeof data.data.RELATED_SYMPTOM_LIST !== "undefined" && typeof data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined") {
            commit("setRelatedSymptomList", data.data.RELATED_SYMPTOM_LIST.symptoms);
        }
        if (typeof data.data.RELATED_SYMPTOM_LIST !== "undefined" && typeof data.data.RELATED_SYMPTOM_LIST.noOtherSymptomsCheck) {
            commit("setNoOtherSymptomsCheck", data.data.RELATED_SYMPTOM_LIST.noOtherSymptomsCheck);
        }
        if (typeof data.data.RELATED_SYMPTOM_LIST !== "undefined" && typeof data.data.RELATED_SYMPTOM_LIST.noOtherSymptoms) {
            commit("setNoOtherSymptoms", data.data.RELATED_SYMPTOM_LIST.noOtherSymptoms);
        }

        if (typeof data.data.SHARED_QUESTIONS !== "undefined") {
            commit("setSharedQuestionsData", data.data.SHARED_QUESTIONS);
        }

        if (typeof data.data.SHORT_ANSWERS_PREVIEW !== "undefined") {
            commit('AssessmentStartStore/setShortAnswersPreview', data.data.SHORT_ANSWERS_PREVIEW, {root: true});
        }

        if (typeof data.data.START_QUESTIONS !== "undefined") {
            commit('AssessmentStartStore/setStartQuestionsData', data.data.START_QUESTIONS, {root: true});
        }

        if (typeof data.data.SYMPTOM_LIST !== "undefined" && typeof data.data.SYMPTOM_LIST.symptoms !== "undefined") {
            commit("setSelectedRelatedSymptomList", data.data.SYMPTOM_LIST.symptoms);
        }
        else if (typeof data.data.SYMPTOM_LIST_PRIORITY !== "undefined" && typeof data.data.SYMPTOM_LIST_PRIORITY.questions !== "undefined") {
            commit('setSelectedRelatedSymptomListPriority', data.data.SYMPTOM_LIST_PRIORITY.questions);
        }

    },

    /**
     * Actions to do when related symptoms checkboxes are toggled.
     * @param {Object} - Vuex: dispatch, commit
     * @param {Object} data - Object containing the following properties:
     *              - {String} "newSymptomState" - new symptom state value. See relatedSymptomStates for values;
     *              - {Number} "symptomCode" - Code of the symptom that has been changed.
     */
    handleChangeRelatedSymptomState({dispatch, commit}, data) {
        switch (data.newSymptomState) {
            case relatedSymptomStates.HAVE_SYMPTOM:
                dispatch("submitCheckSymptomYes", data.symptomCode).then((response) => {

                    if (typeof response.data.data.ASSESSMENT_SYMPTOMS_VIEW !== "undefined") {
                        commit("setDi1PriorityLevelHighest", response.data.data.ASSESSMENT_SYMPTOMS_VIEW.di1PriorityLevelHighest);
                    }

                    if (response.data.data.SYMPTOM_LIST) {
                        commit('setSelectedRelatedSymptomList', response.data.data.SYMPTOM_LIST.symptoms);
                    }
                    else if(response.data.data.SYMPTOM_LIST_PRIORITY){
                        commit('setSelectedRelatedSymptomListPriority', response.data.data.SYMPTOM_LIST_PRIORITY.questions);
                    }
                    dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                    // ------- Refresh RELATED SYMPTOM list. -------
                    if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined"
                            && typeof response.data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined"
                            && response.data.data.RELATED_SYMPTOM_LIST.symptoms.length > 0) {
                        commit("setRelatedSymptomList", response.data.data.RELATED_SYMPTOM_LIST.symptoms);
                    }

                    // ------- Refresh SHARED question list. -------
                    if (typeof response.data.data.SHARED_QUESTIONS !== "undefined") {
                        commit("setSharedQuestionsData", response.data.data.SHARED_QUESTIONS);
                    }
                });
                break;
            case relatedSymptomStates.NOT_HAVE_SYMPTOM:
                dispatch("submitCheckSymptomNo", data.symptomCode).then((response) => {
                    commit("removeSelectedSymptomFromList", data.symptomCode);
                    dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                    // Refresh di1PriorityLevelHighest
                    if (typeof response.data.data.ASSESSMENT_SYMPTOMS_VIEW !== "undefined") {
                        commit("setDi1PriorityLevelHighest", response.data.data.ASSESSMENT_SYMPTOMS_VIEW.di1PriorityLevelHighest);
                    }

                    // ------- Refresh SHARED question list. -------
                    if (typeof response.data.data.SHARED_QUESTIONS !== "undefined") {
                        commit("setSharedQuestionsData", response.data.data.SHARED_QUESTIONS);
                    }

                    // ------- Refresh RELATED SYMPTOM list. -------
                    if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined"
                        && typeof response.data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined"
                        && response.data.data.RELATED_SYMPTOM_LIST.symptoms.length > 0) {
                        commit("setRelatedSymptomList", response.data.data.RELATED_SYMPTOM_LIST.symptoms);
                    }

                    // ------- Refresh SYMPTOMS list. -------
                    if (typeof response.data.data.SYMPTOM_LIST !== "undefined") {
                        commit('setSelectedRelatedSymptomList', response.data.data.SYMPTOM_LIST.symptoms );
                    } else if(response.data.data.SYMPTOM_LIST_PRIORITY){
                        commit('setSelectedRelatedSymptomListPriority', response.data.data.SYMPTOM_LIST_PRIORITY.questions);
                    }
                });
                break;
            case relatedSymptomStates.NONE:
                dispatch("submitUncheckSymptom", data.symptomCode).then((response) => {
                    commit("removeSelectedSymptomFromList", data.symptomCode);
                    dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                    // Refresh di1PriorityLevelHighest
                    if (typeof response.data.data.ASSESSMENT_SYMPTOMS_VIEW !== "undefined") {
                        commit("setDi1PriorityLevelHighest", response.data.data.ASSESSMENT_SYMPTOMS_VIEW.di1PriorityLevelHighest);
                    }

                    // ------- Refresh SHARED question list. -------
                    if (typeof response.data.data.SHARED_QUESTIONS !== "undefined") {
                        commit('setSharedQuestionsData', response.data.data.SHARED_QUESTIONS);
                    }

                    // ------- Refresh RELATED SYMPTOM list. -------
                    if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined"
                        && typeof response.data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined"
                        && response.data.data.RELATED_SYMPTOM_LIST.symptoms.length > 0) {
                        commit("setRelatedSymptomList", response.data.data.RELATED_SYMPTOM_LIST.symptoms);
                    }

                    // ------- Refresh SYMPTOMS list. -------
                    if (typeof response.data.data.SYMPTOM_LIST !== "undefined") {
                        commit('setSelectedRelatedSymptomList', response.data.data.SYMPTOM_LIST.symptoms );
                    } else if(response.data.data.SYMPTOM_LIST_PRIORITY){
                        commit('setSelectedRelatedSymptomListPriority', response.data.data.SYMPTOM_LIST_PRIORITY.questions);
                    }
                });
                break;
        }
    },


    /**
     * Make sure that Selected Symptom List only contains the Main Symptom and the symptoms that are
     *      in Related Symptoms List and have HAVE_SYMPTOM status.
     * @param {Object} - Vuex: commit, getters.
     * @return {Void}
     */
    rectifySelectedSymptomList({commit, getters}) {

        let getMainSymptom = getters.getMainSymptom;
        let getRelatedSymptomList = getters.getRelatedSymptomList;
        let getSelectedRelatedSymptomList = getters.getSelectedRelatedSymptomList;

        getSelectedRelatedSymptomList.forEach((crtSelectedSymptom) => {
            let crtSelectedCode = crtSelectedSymptom.code;

            if (crtSelectedCode !== getMainSymptom.code) {
                let relatedSymptomCorrespondingToCrtSelectedCode = getRelatedSymptomList.filter((symptom) => {
                    return (symptom.code === crtSelectedCode && symptom.state === relatedSymptomStates.HAVE_SYMPTOM);
                });

                if (relatedSymptomCorrespondingToCrtSelectedCode.length === 0) {
                    commit("removeSelectedSymptomFromList", crtSelectedCode);
                }
            }
        });
    },


    /**
     * Tells the server that a related symptom's "Yes" checkbox has been checked.
     * @param {Number} symptomCode
     * @return {Promise}
     */
    submitCheckSymptomYes({commit}, symptomCode) {

        commit('setPendingRequest', true);

        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/selectSymptom', {
                symptomCode: symptomCode
            });
            axiosRequest.then((response) => {
                if ( !Vue.AjaxHelper.hasPendingAjaxRequests() ) {
                    commit('setPendingRequest', false)
                }
                resolve(response);

            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    /**
     * Tells the server that a related symptom's "No" checkbox has been checked.
     * @param {Number} symptomCode
     * @return {Promise}
     */
    submitCheckSymptomNo({commit}, symptomCode) {

        commit('setPendingRequest', true);

        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/selectSymptomWithNo', {
                symptomCode: symptomCode
            });
            axiosRequest.then((response) => {
                if ( !Vue.AjaxHelper.hasPendingAjaxRequests() ) {
                    commit('setPendingRequest', false)
                }
                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },


    /**
     * Tells the server that a related symptom's checkbox ("Yes" or "No") has been unchecked.
     * @param {Number} symptomCode
     * @return {Promise}
     */
    submitUncheckSymptom({commit}, symptomCode) {
        commit('setPendingRequest', true)
        let promise = new Promise((resolve, reject) => {

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/deselectSymptom', {
                symptomCode: symptomCode
            });
            axiosRequest.then((response) => {
                if ( !Vue.AjaxHelper.hasPendingAjaxRequests() ) {
                    commit('setPendingRequest', false)
                }

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },


    /**
     * Send shared question's answer to the server and handle the response.
     * @param {Object} - Vuex: commit, dispatch
     * @param {Object} data - Object containing the following properties: "answerId", "questionId".
     * @return {Promise}
     */
    submitSpecificQuestionAnswer ({commit, dispatch}, data) {

        commit('setPendingRequest', true);

        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/provideAnswer', {
                answerCode: data.newProvidedAnswerCode,
                questionCode: data.questionCode
            });

            axiosRequest.then((response) => {

                dispatch("AssessmentAlertsStore/refreshAlerts", response.data, {root: true});

                // Refresh di1PriorityLevelHighest
                if (typeof response.data.data.ASSESSMENT_SYMPTOMS_VIEW !== "undefined") {
                    commit("setDi1PriorityLevelHighest", response.data.data.ASSESSMENT_SYMPTOMS_VIEW.di1PriorityLevelHighest);
                }

                if (response.data.data.SYMPTOM_LIST) {
                    // ------- Refresh symptom's SPECIFIC question list. -------
                    commit("setSymptomSpecificQuestions", {
                        questionsData: response.data.data.SYMPTOM_LIST.symptoms[0].questionsData,
                        symptomCode: response.data.data.SYMPTOM_LIST.symptoms[0].code
                    });
                }

                // ------- Refresh SHARED question list. -------
                if (typeof response.data.data.SHARED_QUESTIONS !== "undefined") {
                    commit('setSharedQuestionsData', response.data.data.SHARED_QUESTIONS);
                }

                // ------- Refresh RELATED SYMPTOM list. -------
                if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined"
                    && typeof response.data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined") {
                    commit("setRelatedSymptomList", response.data.data.RELATED_SYMPTOM_LIST.symptoms);
                }

                // ----- Refresh SYMPTOM question list ------
                if (typeof response.data.data.SYMPTOM_LIST !== "undefined") {
                    commit('setSelectedRelatedSymptomList', response.data.data.SYMPTOM_LIST.symptoms);
                } else if (response.data.data.SYMPTOM_LIST_PRIORITY) {
                    commit('setSelectedRelatedSymptomListPriority', response.data.data.SYMPTOM_LIST_PRIORITY.questions);
                }

                // ------- Refresh VITAL PARAMETERS data. -------
                if (typeof response.data.data.VITAL_PARAMETERS !== "undefined") {
                    dispatch('VitalParametersStore/setupVitalParameters', response.data.data.VITAL_PARAMETERS, {root: true});
                }

                dispatch("rectifySelectedSymptomList");

                if ( !Vue.AjaxHelper.hasPendingAjaxRequests() ) {
                      commit('setPendingRequest', false)
                }
                resolve(response);

            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

            return promise;

    },

    /**
     * Send shared question's answer to the server and handle the response.
     * @param {Object} - Vuex: commit, dispatch
     * @param {Object} data - Object containing the following properties: "answerId", "questionId".
     * @return {Promise}
     */
    submitSharedQuestionAnswer ({commit, dispatch}, data) {

            commit('setPendingRequest', true);

        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/provideAnswer', {
                answerCode: data.newProvidedAnswerCode,
                questionCode: data.questionCode
            });
            axiosRequest.then((response) => {

                dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                // Refresh di1PriorityLevelHighest
                if (typeof response.data.data.ASSESSMENT_SYMPTOMS_VIEW !== "undefined") {
                    commit("setDi1PriorityLevelHighest", response.data.data.ASSESSMENT_SYMPTOMS_VIEW.di1PriorityLevelHighest);
                }

                // ----- Refresh SYMPTOM question list ------
                if(typeof response.data.data.SYMPTOM_LIST !== "undefined") {
                    commit('setSelectedRelatedSymptomList', response.data.data.SYMPTOM_LIST.symptoms );
                }

                // ------- Refresh SHARED question list. -------
                if (typeof response.data.data.SHARED_QUESTIONS !== "undefined") {
                    commit('setSharedQuestionsData', response.data.data.SHARED_QUESTIONS);
                }

                // ------- Refresh RELATED SYMPTOM LIST. -------
                if (typeof response.data.data.RELATED_SYMPTOM_LIST !== "undefined"
                        && typeof response.data.data.RELATED_SYMPTOM_LIST.symptoms !== "undefined") {
                    commit("setRelatedSymptomList", response.data.data.RELATED_SYMPTOM_LIST.symptoms);
                }

                // ------- Refresh VITAL PARAMETERS data. -------
                if (typeof response.data.data.VITAL_PARAMETERS !== "undefined") {
                    dispatch('VitalParametersStore/setupVitalParameters', response.data.data.VITAL_PARAMETERS, {root: true});
                }

                dispatch("rectifySelectedSymptomList");

                if ( !Vue.AjaxHelper.hasPendingAjaxRequests() ) {
                    commit('setPendingRequest', false)
                }

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    submitAssessmentType({commit}, isPriorityListEnabled) {
        let promise = new Promise((resolve, reject) => {

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/setAssessmentPriorityList', {
                value: isPriorityListEnabled
            });
            axiosRequest.then((response) => {

                /* SET COOKIE FOR VIEW MODE */
                function setCookie(name, value, days) {
                    let expires = "";
                    if (days) {
                        let date = new Date();
                        date.setTime(date.getTime() + (days*24*60*60*1000));
                        expires = "; expires=" + date.toUTCString();
                    }
                    document.cookie = name + "=" + (value || "")  + expires +"; path=/";
                }

                if(isPriorityListEnabled === true){

                    setCookie('view', true, 366);
                    commit('setMustShowAssessmentList', true);

                } else if(isPriorityListEnabled === false) {

                    setCookie('view', false, 366);
                    commit('setMustShowAssessmentList', false)

                }
                if(typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) { // returnCode=0 means success.
                    resolve(response);
                }
                else {
                    reject("Failed to change the view.");
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });

        });

        return promise;
    },

    updateAssessmentTypeByAppProp({commit, dispatch, rootGetters}) {

        let isPriorityListEnabled = null;
        const guiVariantsAvailable = rootGetters['TranslationStore/getAppPropertyValueArray']("GUI_VARIANTS_AVAILABLE", {mustUppercaseAll: true});

        if (guiVariantsAvailable && guiVariantsAvailable.length === 1) {
            if (guiVariantsAvailable[0] === guiVariants.PRIORITY_LIST) {
                isPriorityListEnabled = true;
            }
            else if (guiVariantsAvailable[0] === guiVariants.SYMPTOM_VIEW) {
                isPriorityListEnabled = false;
            }
        }

        const userData = rootGetters['UserStore/getUserData'];

        if (isPriorityListEnabled !== null && userData.username != null) {
            dispatch("submitAssessmentType", isPriorityListEnabled);

            if (router.currentRoute.name === 'AssessmentStartPage' && isPriorityListEnabled) {
                router.push({name: 'AssessmentStartListPage'});
            }
            else if (router.currentRoute.name === 'AssessmentStartListPage' && !isPriorityListEnabled) {
                router.push({name: 'AssessmentStartPage'});
            }
            else if (router.currentRoute.name === 'SymptomsQuestionsPage' && isPriorityListEnabled) {
                router.push({name: 'AssessmentSymptomsPriorityListPage'});
            }
            else if (router.currentRoute.name === 'AssessmentSymptomsPriorityListPage' && !isPriorityListEnabled) {
                router.push({name: 'SymptomsQuestionsPage'});
            }
        }

    }
};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    /**
     * Setter the di1PriorityLevelHighest
     * @param {Object} state
     * @param {Number} di1PriorityLevelHighest
     */
    setDi1PriorityLevelHighest (state, di1PriorityLevelHighest) {
        state.di1PriorityLevelHighest = di1PriorityLevelHighest;
    },

    /**
     * Setter for Related Symptom list.
     * @param {Object} state
     * @param {Array} relatedSymptoms
     */
    setRelatedSymptomList (state, relatedSymptoms) {
        state.relatedSymptomList = relatedSymptoms;
    },

    /**
     * Setter for selected symptom list.
     * @param {Object} state
     * @param {Array} value
     */
    setSelectedRelatedSymptomList (state, value) {
        state.selectedRelatedSymptomList = value;
    },


    /**
     * Set specific question(s) to a symptom.
     * @param {Object} state
     * @param {Object} data - {symptomCode, questionsData}
     */
    setSymptomSpecificQuestions (state, data) {
        // @TODO Prevent DUPLICATE IDs.
        let symptomItemIndex = state.selectedRelatedSymptomList.findIndex((symptom) => {
            return symptom.code == data.symptomCode;
        });

        if (symptomItemIndex !== -1 && typeof state.selectedRelatedSymptomList[symptomItemIndex] !== "undefined") {
            state.selectedRelatedSymptomList[symptomItemIndex].questionsData = data.questionsData;
        }
    },

    /**
     * Setter for Shared Questions initial data.
     * @param {Object} state
     * @param {Object} value
     */
    setSharedQuestionsData (state, value) {
        state.sharedQuestionsData = value;
    },

    /**
     * Setter for MAIN SYMPTOM Shared Questions initial data.
     * @param {Object} state
     * @param {Object} value
     */

    setMainSymptom (state, value) {
        state.selectedMainSymptom = value;
    },

    // --------------------- ADD items to lists ---------------------

    /**
     * Add a symptom to the list of selected symptoms.
     * @param {Object} state
     * @param {Object} symptomObjToAppend
     */
    appendSelectedSymptomToList (state, symptomObjToAppend) {
        // @TODO Prevent DUPLICATE IDs.
        state.selectedRelatedSymptomList = state.selectedRelatedSymptomList.concat(symptomObjToAppend);
    },

    // --------------------- REMOVE items from lists ---------------------

    /**
     * Delete a symptom from selected symptoms list.
     * @param {Object} state
     * @param {Number} symptomCodeToRemove
     */
    removeSelectedSymptomFromList (state, symptomCodeToRemove) {
        state.selectedRelatedSymptomList = state.selectedRelatedSymptomList.filter((crtSymptom) => {
            return crtSymptom.code !== symptomCodeToRemove;
        });
    },

    // ----------------------------------------------------------

    setIsQuestionListModeEnabled (state, newVal) {
        state.isQuestionListModeEnabled = newVal;
    },

    setMustShowFullQuestion (state, newVal) {
        state.mustShowFullQuestion = newVal;
    },

    disableFooterBtnNext (state) {
        state.footerBtnNext.isEnabled = false;
    },
    setSelectedRelatedSymptomListPriority (state, value) {
        state.selectedRelatedSymptomListPriority = value;
    },
    setSymptomDescription(state, newVal) {
        state.symptomDescription = newVal;
    },
    setSymptomCode(state, newVal) {
        state.symptomCode = newVal;
    },
    setMustShowAssessmentList (state, newVal) {
        state.mustShowAssessmentList = newVal;
    },
    setSymptomName(state, newVal) {
        state.symptomName = newVal;
    },
    setSymptomText(state, newVal) {
        state.symptomText = newVal;
    },
    setRelatedSymptomName(state, newVal) {
        state.relatedSymptomName = newVal;
    },
    setAnswerCode(state, newVal) {
        state.answerCode = newVal;
    },
    setNoOtherSymptomsCheck(state, newVal) {
        state.noOtherSymptomsCheck = newVal;
    },
    setNoOtherSymptoms(state, newVal) {
        state.noOtherSymptoms = newVal;
    },
    setPendingRequest(state, newVal) {
        state.pendingRequest = newVal
    },
    setSymptomType(state, newVal) {
        state.symptomType = newVal;
    },
    // ----------------------------------------------------------

    resetStore (state) {
        state.di1PriorityLevelHighest            = defaultState.di1PriorityLevelHighest;
        state.relatedSymptomList                 = defaultState.relatedSymptomList;
        state.selectedRelatedSymptomList         = defaultState.selectedRelatedSymptomList;
        state.sharedQuestionsData                = defaultState.sharedQuestionsData;

        state.isQuestionListModeEnabled          = defaultState.isQuestionListModeEnabled;
        state.mustShowFullQuestion               = defaultState.mustShowFullQuestion;
        state.footerBtnNext = {
                                isEnabled:         defaultState.footerBtnNext.isEnabled
        };
        state.selectedMainSymptom                = defaultState.selectedMainSymptom;
        state.selectedRelatedSymptomListPriority = defaultState.selectedRelatedSymptomListPriority;
        state.symptomDescription                 = defaultState.symptomDescription;
        state.symptomCode                        = defaultState.symptomCode;
        state.symptomName                        = defaultState.symptomName;
        state.symptomText                        = defaultState.symptomText;
        state.relatedSymptomName                 = defaultState.relatedSymptomName;
        state.answerCode                         = defaultState.answerCode;
        state.noOtherSymptomsCheck               = defaultState.noOtherSymptomsCheck;
        state.noOtherSymptoms                    = defaultState.noOtherSymptoms;
        state.pendingRequest                     = defaultState.pendingRequest;
        state.symptomType                        = defaultState.symptomType;
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/SymptomsQuestionsStore.js